// extracted by mini-css-extract-plugin
module.exports = {"check-label":"Toggle_check-label__xBguD"};